import version_info from 'version/version.json';

// configuration for test server
export const environment = {
  production: false,
  graphql_http: 'https://api-dev.wind-log.com/graphql',
  graphql_http2: 'https://api-v2-dev.wind-log.com/graphql',
  graphql_datwind: 'https://ml-dev-datwind3.wind-log.com/graphql',
  graphql_notifications: 'https://in-app-notification-api-dev.greenpowermonitor.com/graphql',
  graphql_multitech: 'https://multitech-federated-api-dev.greenpowermonitor.com/graphql',
  graphql_datwind_report: 'https://ml-dev-datwind3.wind-log.com/report',
  graphql_ws: 'wss://api-dev.wind-log.com/graphql',
  graphql_ws2: 'wss://api-v2-dev.wind-log.com/graphql',
  graphql_ws_datwind: 'wss://ml-dev-datwind3.wind-log.com/',
  api_analyze_url: 'wss://wind-log-oldbackend-dev.wind-log.com',
  sso_url: 'https://sso-dev.greenpowermonitor.com/auth',
  datwind_file_server: 'https://ml-dev-datwind3.wind-log.com/',
  file_server: 'https://file-server-dev.energy-log.com',
  image_server: 'https://image-server-dev.energy-log.com',
  shared_server: 'https://shared-data-dev.energy-log.com',
  fileURL: 'https://data-studio-file-dev.wind-log.com',
  dataStudioURL: 'https://data-studio-service-dev.wind-log.com',
  horizonPostErrorServerURL: 'https://mailer-dev.greenpowermonitor.com/horizon-error/post-error',
  auth_enabled: true,
  keycloak_init_options: {
    onLoad: 'login-required',
    checkLoginIframe: false
  },

  versionInfo: version_info,
  integration: false,
	mixpanel_token: '3b2d9b5764cb1652c472cb13209b21b2',
  // clarity_token: 'lj456xcztm', // this is the real one, the one below is temporary for testing
  clarity_token: 'z8dd1eqbr5',
  gtm_token: 'GTM-NL6FSBTF',
};
